import { create } from "zustand";
import { generateInvoice, invoiceHistory, uploadInvoice ,creditNoteHistory,generateCreditNote,uploadCreditNote, downloadInvoice,invoiceUrl, downloadInvoiceURL} from "../api_layer/api";

export const useInvoiceStore = create((set) => ({
  invoiceHisData: [],
  creditData:[],
  updateData: [],
  invoiceUrl:{},
  downloadUrl:{},
  invHisLoading: false,
  caseDataToLoading: false,
  urlLoading:false,
  updateLoading: false,
  error: null,
  postGenerateInvoice: async (id, setToaster, refresh, setRefresh) => {
    try {
      set({ caseDataLoading: true, error: null });
      const response = await generateInvoice(id);
      setToaster("Generate Invoice", "Invoice generated Successfully", "success")
      set({ caseData: response.data, caseDataLoading: false });
      setRefresh(!refresh);
    } catch (error) {
        setToaster("Generate Invoice", "Invoice generated Fail", "danger")
      set({ error: error.message, caseDataLoading: false });
    }
  },
  postGenerateCreditNote: async (id, setToaster, refresh, setRefresh) => {
    try {
      set({ caseDataLoading: true, error: null });
      const response = await generateCreditNote(id);
      setToaster("Credit Note", "Credit note generated Successfully", "success")
      set({ caseData: response.data, caseDataLoading: false });
      setRefresh(!refresh);
    } catch (error) {
        setToaster("Credit Note", "Credit Note generation Failed", "danger")
      set({ error: error.message, caseDataLoading: false });
    }
  },
  fetchInvoiceHistory: async (id) => {
    try {
      set({ invHisLoading: true, error: null });
      const response = await invoiceHistory();
      set({ invoiceHisData: response.data, invHisLoading: false });
    } catch (error) {
      set({ error: error.message, invHisLoading: false });
    }
  },
  fetchCreditHistory: async () => {
    try {
      set({ invHisLoading: true, error: null });
      const response = await creditNoteHistory();
      set({ creditData: response.data, invHisLoading: false });
    } catch (error) {
      set({ error: error.message, invHisLoading: false });
    }
  },
  postDownloadInvoice: async (payload, setToaster,clear, setClear) => {
    try {
      set({ invHisLoading: true, error: null });
      const response = await downloadInvoice(payload);
      setToaster("Download Invoice", "Your report will be sent to your email shortly", "success")
      setClear(!clear);
      set({ creditData: response.data, invHisLoading: false });
    } catch (error) {
      setToaster("Download Invoice", "Downloading report is failed", "danger")
      set({ error: error.message, invHisLoading: false });
    }
  },
  updateInvoice: async (payload, setToaster) => {
    try {
      set({ updateLoading: true, error: null });
      const response = await uploadInvoice(payload);
      set({ updateData: response.data, updateLoading: false });
      setToaster("Invoice Upload", "Invoice Uploaded Successfully", "success");
    } catch (error) {
        if(error.response.status===400){
            setToaster("Invoice Upload",error.response.data.message, "danger")
        }
        else{
  
            setToaster("Invoice Upload", "Invoice Uploaded Failed", "danger");
        }
      set({ error: error.message, updateLoading: false });
    }
  },
  updateCredit: async (payload, setToaster) => {
    try {
      set({ updateLoading: true, error: null });
      const response = await uploadCreditNote(payload);
      set({ updateData: response.data, updateLoading: false });
      setToaster("Credit Note", "Credit Note Uploaded Successfully", "success");
    } catch (error) {
        if(error.response.status===400){
         
            setToaster("Credit Note",error.response.data.message, "danger")
        }
        else{
            setToaster("Credit Note", "Credit Note Uploaded Failed", "danger");
        }
      set({ error: error.message, updateLoading: false });
    }
  },
  getInvoiceUrl: async (payload) => {
    try {
      set({ urlLoading: true, error: null });
      const response = await invoiceUrl(payload);
      set({ invoiceUrl: response.data, urlLoading: false });
    } catch (error) {
      set({ error: error.message, urlLoading: false });
    }
  },
  getDownloadInvoiceUrl: async (payload) => {
    try {
      set({ urlLoading: true, error: null });
      const response = await downloadInvoiceURL(payload);
      set({ downloadUrl: response.data, urlLoading: false });
    } catch (error) {
      set({ error: error.message, urlLoading: false });
    }
  },
}));
